import React, { useState } from "react";
import Header from "../_components/common/Header";
import "../_css/Static.css";
import { useNavigate, useParams } from "react-router-dom";
import Terms from "../_components/UI/Terms";
import Privacy from "../_components/UI/Privacy";
import About from "../_components/UI/About";

const StaticContent = () => {
  const { name } = useParams();
  const navigate = useNavigate();

  return (
    <div className='page-main'>
      <Header name={["Static Content"]} />

      <div className="static-container">
        <div className="static-menu">
          <div
            onClick={() => navigate("/static-content/terms-and-conditions")}
            className="static-menu-item"
            id={name == "terms-and-conditions" && "static-menu-active"}
          >
            Terms and Conditions
          </div>
          <div
            onClick={() => navigate("/static-content/privacy-policy")}
            className="static-menu-item"
            id={name == "privacy-policy" && "static-menu-active"}
          >
            Privacy Policy
          </div>
          <div
            onClick={() => navigate("/static-content/about-us")}
            className="static-menu-item"
            id={name == "about-us" && "static-menu-active"}
          >
            About Us
          </div>
        </div>

        <div className="static-title">
          {(name == "terms-and-conditions" && "Terms And Conditions") ||
            (name == "privacy-policy" && "Privacy Policy") ||
            (name == "about-us" && "About Us")}
        </div>

        {(name == "terms-and-conditions" && <Terms />) ||
          (name == "privacy-policy" && <Privacy />) ||
          (name == "about-us" && <About />)}
      </div>
    </div>
  );
};

export default StaticContent;
